import { isRouteViaCMM } from "./isRouteViaCMM";

interface BuildPrimaryCareRowDataParams {
  key: string;
  outcome: string;
  routeVia: string;
  poc: string;
  comments?: string;
}

export const buildPrimaryCareRowData = (
  params: BuildPrimaryCareRowDataParams,
): Record<string, string> => {
  const { key, outcome, routeVia, poc, comments } = params;

  const rowData: Record<string, string> = {
    second_stp_status: "QA Fetched",
    response_status: outcome,
    route_via: routeVia,
    poc,
    comments: comments ?? "",
  };

  if (isRouteViaCMM(routeVia)) {
    rowData.covermymed_id = key;
  }

  return rowData;
};
